import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import NumberFormat from "react-number-format";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme: any) => ({
  linesRoot: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function HistoryBlockItem(props: any) {
  const { data } = props;
  console.log({data})

  return (
    <>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <b>Invoice Id</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.InvoiceId}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <b>Payment ID</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.PaymentId}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <b>Vendor ID</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.VendorId}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <b>Currency Type</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.PaymentType}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <b>Payment Instrument</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.PaymentGateway}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <b>Receipt Url</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.ReceiptUrl == 'none' ? '' : data.ReceiptUrl }</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <b>Date</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <Typography noWrap>
              {moment(data.Date).format("DD/MM/YYYY")}
            </Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <b>Currency</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <Typography noWrap>{data.CurrencyCode}</Typography>
          </ListItemText>
        </List>
      </Grid>

      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <b>Paid Amount</b>
          </ListItemText>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List>
          <ListItemText>
            <Typography noWrap>
              <NumberFormat
                defaultValue={"0.00"}
                value={data.PaidAmount}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                prefix={data.CurrencyCode + " "}
              />
            </Typography>
          </ListItemText>
        </List>
      </Grid>
    </>
  );
}

function BlockLinesAccordion({ state }: any) {
  const classes = useStyles();

  return (
    <>
      {state.map((line: any, index: any) => (
        <div className={classes.linesRoot}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>{line.item}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <b>Unit Price</b>
                    </ListItemText>
                  </List>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <Typography noWrap>
                        <NumberFormat
                          defaultValue={"0.00"}
                          value={line.unitPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </Typography>
                    </ListItemText>
                  </List>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <b>Quantity</b>
                    </ListItemText>
                  </List>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <Typography noWrap>{line.quantity}</Typography>
                    </ListItemText>
                  </List>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <b>Discount</b>
                    </ListItemText>
                  </List>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <Typography noWrap>
                        <NumberFormat
                          defaultValue={"0.00"}
                          value={line.discount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </Typography>
                    </ListItemText>
                  </List>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <b>Amount</b>
                    </ListItemText>
                  </List>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <List>
                    <ListItemText>
                      <Typography noWrap>
                        <NumberFormat
                          defaultValue={"0.00"}
                          value={line.amount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </Typography>
                    </ListItemText>
                  </List>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <List>
                    <ListItemText>
                      <b>Additional Details</b>
                    </ListItemText>
                  </List>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <List>
                    <ListItemText>
                      <Typography>{line.additionalDetails}</Typography>
                    </ListItemText>
                  </List>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </>
  );
}
